import { parseJsonSafe } from '../../utils/json/parseJsonSafe';

export const getSessionUserInfo = () => parseJsonSafe(sessionStorage.getItem('userInfo'));
